module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-71.b9a62036.svg";